// Forces the browser's native copy event to emit plain text only. Selecting
// text inside a styled ancestor (e.g. a message bubble's translucent
// theme-colored Paper background) and copying via Ctrl+C/right-click Copy
// produces both a text/plain AND a text/html clipboard entry — paste targets
// that respect rich text carry the ancestor's background/styling from that
// html entry. Overriding the clipboard data with text/plain only (and
// preventing the default rich-text write) makes every copy in the app behave
// like plain-text copy, regardless of what DOM the selection spans.
export function forcePlainTextCopy(event, selectionText) {
  if (!selectionText) return false
  event.preventDefault()
  event.clipboardData.setData('text/plain', selectionText)
  return true
}
